import comp from "./GradesCell";

export default comp;
